const ReassuranceBlock = () => {
  return null;
};

export default ReassuranceBlock;
